import React, { useState } from 'react'
import { setTag } from '../../../Api Methods/Api';
import Input from '../../CustomDropDown/Input/Input';
import Button1 from '../../UI/Button/Button1';
import classes2 from "../../forms/InviteUserForm.module.css"
import classes from "./SetTag.module.css"
import DataManager from '../../../hooks/DataManager';

const SetPortalName = ({ placeholder, HandleCloseModal, handleSaveName, setNameSet }) => {

    const dataManager = new DataManager();
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');

    const [portalName, setPortalName] = useState('');

    

    const handleInputChange = (event) => {
        setPortalName(event.target.value);
        setNameSet(event.target.value)
        dataManager.setItem('portalName', event.target.value)
    };

    const handleCancel = () => {
        setPortalName('');
        HandleCloseModal();
    };

    handleSaveName = () => {
        setNameSet(portalName)
    }

    return (
        <form onSubmit={handleSaveName} method="dialog" >
            <Input
                type="text"
                value={portalName}
                onChange={handleInputChange}
                placeholder={placeholder}
            />
        </form>
    )
}

export default SetPortalName;